import { Crumb } from 'lib/raul/types';
import { Breadcrumbs } from 'lib/raul';

interface Action {
  icon?: string;
}

interface Props {
  actions?: Action[];
  avatar?: JSX.Element | undefined;
  breadcrumbs?: Crumb[];
  children?: JSX.Element | undefined;
  className?: string;
  primaryText: string;
  secondaryText?: string;
}

const Header = ({
  avatar,
  breadcrumbs,
  children,
  className,
  primaryText,
  secondaryText,
}: Props) => {
  const AvatarHeader = () => (
    <div className="r-flex r-flex-no-wrap r-justify-start">
      <div className="r-flex-none r-self-start">{avatar}</div>
      <div className="r-ml-3">
        <h1 className="r-text-xl r-font-bold r-leading-none">{primaryText}</h1>
        <p className="r-opacity-80">{secondaryText}</p>
      </div>
    </div>
  );

  const StandardHeader = () => (
    <div className="r-justify-start">
      <h1 className="r-text-xl r-font-bold r-leading-none">{primaryText}</h1>
      {secondaryText && <p className="r-text-l">{secondaryText}</p>}
    </div>
  );

  return (
    <div className={`${className} r-px-6 md:r-px-10 r-pt-6`}>
      {breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} />}
      <div className="r-flex r-justify-between r-items-end r-mt-3 r-mb-6">
        {avatar ? <AvatarHeader /> : <StandardHeader />}
        <div className="r-pl-16 r-flex-none">{children}</div>
      </div>
    </div>
  );
};

export default Header;
